export interface FeatureFlag {
  name: string;
  enabled: boolean;
}

export default class FeatureFlagsService {
  constructor(private readonly serverUrl: string) {
    this.getBy = this.getBy.bind(this);
  }

  getBy(appName: string) {
    const url = `${this.serverUrl}/feature-flags/${appName}`;
    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => {
      if (response.ok) {
        return response.json() as Promise<FeatureFlag[]>;
      }
      throw new Error('Something went wrong');
    });
  }
}
